/** Session-folder prefixes that should not resolve against the workspace/CWD. */
const SESSION_RELATIVE_PREFIXES = [
  'plans/',
  'data/',
  'attachments/',
  'downloads/',
  'long_responses/',
] as const;

export interface ResolveChatFileOpenPathOptions {
  sessionFolderPath?: string;
  workingDirectory?: string;
  workspaceRootPath?: string;
}

/**
 * Resolve a chat/markdown file target to an openable filesystem path.
 *
 * Agents often write `./data/foo.csv` or `data/foo.csv`. Those live in the
 * session folder, not the workspace root — the files drawer already knows that.
 */
export function resolveChatFileOpenPath(
  rawPath: string,
  options: ResolveChatFileOpenPathOptions,
): string {
  const path = rawPath.startsWith('file://') ? rawPath.replace(/^file:\/\//, '') : rawPath;
  if (path.startsWith('/') || path.startsWith('~/')) return path;

  const cleanedPath = path.replace(/^\.\//, '');
  const sessionFolderPath = options.sessionFolderPath?.replace(/\/+$/, '');

  if (
    sessionFolderPath &&
    SESSION_RELATIVE_PREFIXES.some((prefix) => cleanedPath.startsWith(prefix))
  ) {
    return `${sessionFolderPath}/${cleanedPath}`;
  }

  const baseDir = options.workingDirectory || options.workspaceRootPath;
  if (!baseDir) return cleanedPath;

  return `${baseDir.replace(/\/+$/, '')}/${cleanedPath}`;
}
